const _excluded = ["onChange", "onFocus", "onBlur", "value", "size", "error", "className", "readOnly", "disabled", "placeholder", "numberFormat", "mask", "dateFormat", "dataTestId", "noCalendar"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { InputDecorators, InputDecoratorsSeparator } from "../../../base";
import { useFormCommonProps } from "../../../context/form-common";
import { defaultDateFormat, defaultMask, defaultNumberFormat, InputDateCalendarIcon, InputDateOverlay, InputDateSingle } from "../base";
import clsx from 'clsx';
import { nanoid } from 'nanoid';
export const InputDate = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _components$IconList;
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onFocus,
      onBlur,
      value,
      size,
      error,
      className,
      readOnly,
      disabled,
      placeholder,
      numberFormat = defaultNumberFormat,
      mask = true,
      dateFormat = defaultDateFormat,
      dataTestId,
      noCalendar
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const defaultInputDateComponents = {
    IconList: [/*#__PURE__*/React.createElement(InputDateOverlay, {
      key: nanoid(4).toString(),
      OverlayTrigger: InputDateCalendarIcon,
      dateFormat: dateFormat,
      readOnly: readOnly,
      disabled: disabled,
      error: error
    }, /*#__PURE__*/React.createElement(InputDateSingle, _extends({
      dateFormat: dateFormat,
      value: value,
      onChange: onChange,
      readOnly: readOnly,
      disabled: disabled
    }, rest)))]
  };
  const {
    components = defaultInputDateComponents
  } = rest;
  const inputRef = React.useRef(null);
  const flatpickrRef = React.useRef(null);
  React.useImperativeHandle(ref, () => ({
    get input() {
      return inputRef.current;
    },
    get flatpickr() {
      return flatpickrRef.current;
    }
  }), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputDecorators, {
    className: clsx('input-date-container', className),
    inputRef: inputRef,
    onChange: onChange,
    onFocus: e => onFocus && onFocus(e),
    onBlur: e => onBlur && onBlur(e),
    size: size,
    error: error,
    value: value,
    readOnly: readOnly,
    disabled: disabled,
    input: {
      type: 'text',
      placeholder,
      mask: typeof mask === 'boolean' ? mask ? defaultMask : undefined : mask,
      format: numberFormat,
      dataTestId: dataTestId
    },
    suffix: !noCalendar && /*#__PURE__*/React.createElement(React.Fragment, null, (_components$IconList = components.IconList) === null || _components$IconList === void 0 ? void 0 : _components$IconList.map((icon, index) => {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(InputDecoratorsSeparator, null), icon);
    }))
  })));
});